import React from "react";
import ArtisteInconnu from "../data/images/artistes/ArtisteInconnu.png"; // Image de secours

export default function ArtistPortfolio({ artists }) {
  return (
    <div className="artist-grid">
      {artists.map((artist) => (
        <div key={artist.id} className="artist-card">
          <img 
            src={artist.image || ArtisteInconnu} 
            alt={artist.name} 
            className="artist-image"
            onError={(e) => { e.target.src = ArtisteInconnu; }} 
          />
          <h3 className="artist-name">{artist.name}</h3>
          <p className="artist-bio">{artist.bio}</p>
        </div>
      ))}
    </div>
  );
}
